module.exports = "/dist/fafacae60c9b5a39505cf2307cac81d1.eot";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-roboto/files/roboto-latin-100italic.eot
// module id = 25
// module chunks = 0